// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Login page ── */
.lp {
  min-height: 100dvh;
  display: grid;
  grid-template-columns: 1fr 1fr;
  background: #f0ebe2;
}

/* ── LEFT PANEL ── */
.lp__left {
  position: relative;
  overflow: hidden;
  min-height: 100dvh;
}

.lp__left-bg {
  position: absolute;
  inset: 0;
}

.lp__left-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center 35%;
}

.lp__left-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(175deg, rgba(20, 30, 18, 0.65) 0%, rgba(20, 30, 18, 0.3) 40%, rgba(15, 22, 12, 0.8) 90%);
}

.lp__left-content {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: clamp(2rem, 5vw, 3.5rem);
}

.lp__left-logo {
  display: flex;
  align-items: center;
  gap: 0.8rem;
}

.lp__brand-name {
  font-weight: 700;
  font-size: 0.938rem;
  letter-spacing: 0.22em;
  color: #fff;
  margin: 0;
  line-height: 1.1;
}
.lp__brand-sub {
  font-size: 0.51rem;
  letter-spacing: 0.2em;
  color: rgba(255, 255, 255, 0.45);
  margin: 0;
  text-transform: uppercase;
  line-height: 1.4;
}

.lp__left-hero {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0.85rem;
}

.lp__hero-headline {
  font-family: var(--font-serif);
  font-size: clamp(1.8rem, 3.5vw, 3rem);
  font-weight: 600;
  color: #fff;
  margin: 0;
  line-height: 1.2;
}
.lp__hero-rust {
  color: #d4784a;
  display: block;
}

.lp__hero-rule {
  display: block;
  width: 2.5rem;
  height: 3px;
  background: #b85c38;
  border-radius: 2px;
}

.lp__hero-sub {
  font-size: clamp(0.85rem, 1.2vw, 1rem);
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.65;
  margin: 0;
}

.lp__left-badge {
  display: flex;
}
.lp__left-badge .wws__badge {
  width: 90px !important;
  height: 90px !important;
}

/* ── RIGHT PANEL ── */
.lp__right {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: clamp(2rem, 5vw, 3rem) clamp(1.5rem, 4vw, 2.5rem);
  gap: 1.25rem;
  background: #f0ebe2;
}

.lp__card {
  background: #f0ebe2;
  border: 1px solid rgba(27, 27, 27, 0.1);
  border-radius: 14px;
  padding: clamp(1.75rem, 4vw, 2.5rem);
  width: 100%;
  max-width: 440px;
  position: relative;
  /* overflow: hidden; */
  box-shadow: 0 4px 24px rgba(27, 27, 27, 0.08);
}

.lp__card-mtn {
  position: absolute;
  top: -15%;
  right: 0;
  width: 55%;
  height: 42%;
  overflow: hidden;
  pointer-events: none;
  opacity: 0.22;
}
.lp__card-mtn img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center top;
  filter: grayscale(1) contrast(1.1);
}

.lp__card-title {
  font-family: var(--font-serif);
  font-size: clamp(1.5rem, 2.5vw, 1.9rem);
  font-weight: 600;
  color: #1b1b1b;
  margin: 0 0 0.35rem;
  position: relative;
}

.lp__card-sub {
  font-size: 0.867rem;
  color: #6b6258;
  margin: 0 0 1.75rem;
  line-height: 1.55;
}

/* Form */
.lp__form {
  display: flex;
  flex-direction: column;
  gap: 0.95rem;
}
.lp__field {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}
.lp__label {
  font-size: 0.836rem;
  font-weight: 600;
  color: #1b1b1b;
}

.lp__label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.lp__forgot {
  font-size: 0.765rem;
  color: #b85c38;
  text-decoration: none;
  font-weight: 600;
}
.lp__forgot:hover {
  color: #9e4a28;
}

.lp__input-wrap {
  position: relative;
  display: flex;
  align-items: center;
}
.lp__input-icon {
  position: absolute;
  left: 0.9rem;
  font-size: 0.867rem;
  color: rgba(27, 27, 27, 0.3);
  pointer-events: none;
}

.lp__input {
  width: 100%;
  border: 1px solid rgba(27, 27, 27, 0.18);
  border-radius: 8px;
  background: #fff;
  padding: 0.8rem 0.9rem 0.8rem 2.6rem;
  font-size: 0.918rem;
  color: #1b1b1b;
  outline: none;
  transition:
    border-color 0.2s,
    box-shadow 0.2s;
}
.lp__input::placeholder {
  color: rgba(27, 27, 27, 0.3);
}
.lp__input:focus {
  border-color: #b85c38;
  box-shadow: 0 0 0 3px rgba(184, 92, 56, 0.1);
}

.lp__pw-toggle {
  position: absolute;
  right: 0.9rem;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 0.969rem;
  color: rgba(27, 27, 27, 0.3);
  padding: 0.2rem;
}
.lp__pw-toggle:hover {
  color: #1b1b1b;
}

/* Remember */
.lp__remember {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  font-size: 0.857rem;
  color: #1b1b1b;
  cursor: pointer;
}
.lp__remember input {
  display: none;
}
.lp__checkbox-mark {
  width: 1.05rem;
  height: 1.05rem;
  border: 1.5px solid #b85c38;
  border-radius: 3px;
  background: #b85c38;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  position: relative;
}
.lp__checkbox-mark::after {
  content: "";
  width: 0.48rem;
  height: 0.28rem;
  border-left: 2px solid #fff;
  border-bottom: 2px solid #fff;
  transform: rotate(-45deg) translate(1px, -1px);
  display: block;
}

/* Submit */
.lp__submit {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.6rem;
  width: 100%;
  background: #b85c38;
  color: #fff;
  border: none;
  border-radius: 7px;
  padding: 0.95rem;
  font-weight: 700;
  font-size: 0.836rem;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  cursor: pointer;
  transition: background 0.2s;
  margin-top: 0.15rem;
}
.lp__submit:hover:not(:disabled) {
  background: #9e4a28;
}
.lp__submit:disabled {
  opacity: 0.6;
  cursor: wait;
}

/* OR */
.lp__or {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-block: 0.1rem;
}
.lp__or-line {
  flex: 1 1;
  height: 1px;
  background: rgba(27, 27, 27, 0.12);
}
.lp__or-text {
  font-size: 0.734rem;
  color: rgba(27, 27, 27, 0.38);
  white-space: nowrap;
}

/* Social */
.lp__social {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.6rem;
}
.lp__social-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.55rem;
  border: 1px solid rgba(27, 27, 27, 0.16);
  border-radius: 7px;
  background: #fff;
  padding: 0.72rem 0.5rem;
  font-size: 0.796rem;
  color: #1b1b1b;
  cursor: pointer;
  transition: background 0.15s;
  white-space: nowrap;
}
.lp__social-btn:hover {
  background: rgba(27, 27, 27, 0.04);
}

.lp__signup {
  font-size: 0.836rem;
  color: #6b6258;
  text-align: center;
  margin: 0.85rem 0 0;
}
/* These are <button>s, and they were inheriting the browser's own button
   chrome — a grey face and a rectangular border — so they read as two more
   buttons on a screen that already has one. This is the Forge secondary
   link: no box, underlined so it is still obviously interactive, with
   enough padding to stay a comfortable tap target.
   The colour is the darker rust: #b85c38 measures 4.01:1 on the cream card
   and 4.54:1 on white, and this text is small. (UX-REVIEW LOG-001, LOG-012) */
.lp__signup-link {
  appearance: none;
  -webkit-appearance: none;
  background: none;
  border: none;
  border-radius: 0;
  font: inherit;
  color: #a4502f;
  font-weight: 700;
  text-decoration: underline;
  text-underline-offset: 0.2em;
  cursor: pointer;
  padding: 0.5rem 0.15rem;   /* keeps the tap target tall without a box */
  margin: -0.5rem 0;         /* ...without pushing the line apart */
}

.lp__signup-link:hover { color: #8d4524; }

.lp__signup-link:focus-visible {
  outline: 2px solid #a4502f;
  outline-offset: 2px;
  border-radius: 3px;
}

/* Security */
.lp__security {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  font-size: 0.734rem;
  color: #6b6258;
  max-width: 440px;
  text-align: center;
}
.lp__security svg {
  font-size: 1.122rem;
  flex-shrink: 0;
}

/* ── MOBILE ── matches the image: logo+mountain top, form below, social stacked ── */
@media (max-width: 767.98px) {
  .lp {
    grid-template-columns: 1fr;
    grid-template-rows: auto 1fr;
  }

  .lp__left {
    min-height: 0;
    height: clamp(220px, 50vw, 320px);
  }

  .lp__left-content {
    padding: clamp(1rem, 4vw, 1.75rem);
  }
  .lp__left-hero {
    justify-content: flex-end;
    padding-bottom: 0.5rem;
  }
  .lp__hero-headline {
    font-size: clamp(1.4rem, 6vw, 2rem);
  }
  .lp__hero-sub {
    display: none;
  }
  .lp__left-badge {
    display: none;
  }

  .lp__right {
    padding: var(--sp-5) var(--sp-4);
    justify-content: flex-start;
  }
  .lp__card {
    border-radius: 10px;
  }

  /* On mobile social buttons stack */
  .lp__social {
    grid-template-columns: 1fr;
  }
}

/* ── Mode toggle (OTP vs Password) ── */
.lp__mode-toggle {
  display: flex;
  border: 1.5px solid var(--c-sand, #ddd5c8);
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 1.5rem;
}
.lp__mode-btn {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  padding: 0.6rem 0.5rem;
  font-size: 0.82rem;
  font-weight: 600;
  background: #fff;
  border: none;
  cursor: pointer;
  color: #6b6258;
  border-right: 1.5px solid var(--c-sand, #ddd5c8);
  /* Background and colour change together, so the selected state can never
     paint half-applied. \`transition: all\` used to animate the background
     from near-black to white while the text went from white to grey, and
     both were pale in the middle of the swap. (UX-REVIEW LOG-003) */
  transition: none;
}
.lp__mode-btn:last-child {
  border-right: none;
}
/* The real cause of the white-on-white report. \`.lp__mode-btn:hover\` is a
   more specific selector than \`.lp__mode-btn--active\`, so hovering the
   SELECTED method kept the near-white hover tint underneath its white
   label — permanently, for anyone using a mouse, not just for a frame.
   Hover now applies only to the method you have not chosen.
   (UX-REVIEW LOG-003) */
.lp__mode-btn:hover:not(.lp__mode-btn--active) {
  background: #faf7f2;
}
.lp__mode-btn--active {
  background: #1e2a1e;
  color: #fff;
}

/* ── OTP sent notice ── */
.lp__otp-sent-notice {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  background: rgba(30, 42, 30, 0.06);
  border: 1px solid rgba(30, 42, 30, 0.14);
  border-radius: 8px;
  padding: 0.85rem 1rem;
  margin-bottom: 1.25rem;
}
.lp__otp-sent-icon {
  font-size: 1.35rem;
  color: #1e2a1e;
  flex-shrink: 0;
  margin-top: 2px;
}
.lp__otp-sent-title {
  font-size: 0.85rem;
  font-weight: 700;
  color: #1b1b1b;
  margin: 0 0 0.15rem;
}
.lp__otp-sent-sub {
  font-size: 0.78rem;
  color: #6b6258;
  margin: 0;
}

/* ── OTP input ── */
.lp__input--otp {
  font-size: 1.6rem !important;
  font-weight: 800 !important;
  letter-spacing: 0.35em !important;
  text-align: center !important;
  font-family: monospace !important;
  padding: 0.85rem 1rem !important;
}

/* ── OTP footer actions ── */
.lp__otp-footer {
  display: flex;
  justify-content: space-between;
  margin-top: 0.75rem;
}
.lp__otp-hint {
  font-size: 0.75rem;
  color: #6b6258;
  text-align: center;
  margin-top: 0.75rem;
}

/* ── Link buttons ── */
.lp__link-btn {
  background: none;
  border: none;
  font-size: 0.78rem;
  color: #6b6258;
  cursor: pointer;
  padding: 0;
  transition: color 0.15s;
}
.lp__link-btn:hover {
  color: #b85c38;
}
.lp__link-btn:disabled {
  opacity: 0.45;
  cursor: default;
}

/* ── Error message ── */
.lp__error {
  font-size: 0.8rem;
  font-weight: 600;
  color: #dc2626;
  background: rgba(220, 38, 38, 0.07);
  border: 1px solid rgba(220, 38, 38, 0.2);
  border-radius: 6px;
  padding: 0.55rem 0.75rem;
  margin-bottom: 0.75rem;
}

/* ── Sign in / Create account tabs ── */
.lp__view-tabs {
  display: grid;
  grid-template-columns: 1fr 1fr;
  border-bottom: 1.5px solid #e4dccf;
  margin: 0.25rem 0 1.25rem;
}
.lp__view-tab {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  padding: 0.75rem 0.5rem;
  background: none;
  border: none;
  border-bottom: 3px solid transparent;
  margin-bottom: -1.5px;
  font: inherit;
  font-size: 0.9rem;
  font-weight: 700;
  color: #6b6258;
  cursor: pointer;
  transition: color 0.2s, border-color 0.2s;
}
.lp__view-tab svg { font-size: 1.1rem; }
.lp__view-tab:hover { color: #1b1b1b; }
.lp__view-tab--active { color: #1e2a1e; border-bottom-color: #b85c38; }

.lp__field-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.75rem;
}
@media (max-width: 420px) {
  .lp__field-row { grid-template-columns: 1fr; }
}
.lp__optional { font-weight: 400; color: #8a8178; }

.lp__reg-points {
  list-style: none;
  margin: 0.25rem 0 0;
  padding: 0.9rem 1rem;
  background: #f6f0e8;
  border-radius: 10px;
  display: grid;
  gap: 0.45rem;
}
.lp__reg-points li {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  font-size: 0.8rem;
  color: #4a433c;
  line-height: 1.45;
}
.lp__reg-points svg { color: #16a34a; font-size: 1rem; flex-shrink: 0; margin-top: 0.05rem; }

/* "Stayed with Makua?" under the sign-in form, only when the forum sent them here */
.lp__other-site { margin-top: 1.1rem; padding-top: 0.9rem; border-top: 1px solid rgba(107, 98, 88, 0.18); }

/* Visually hidden, still read by password managers (the new password's username) */
.lp__sr-only { position: absolute; width: 1px; height: 1px; padding: 0; margin: -1px; overflow: hidden; clip: rect(0 0 0 0); white-space: nowrap; border: 0; }
.lp__field-hint { margin: 0.35rem 0 0; font-size: 0.78rem; color: #6b6258; }
`, "",{"version":3,"sources":["webpack://./src/portal/LoginPage.css"],"names":[],"mappings":"AAAA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,oHAAoH;AACtH;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gCAAgC;EAChC,SAAS;EACT,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,qCAAqC;EACrC,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;EACtC,+BAA+B;EAC/B,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,aAAa;AACf;AACA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,0DAA0D;EAC1D,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;EACvC,mBAAmB;EACnB,oCAAoC;EACpC,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;EAC9B,uCAAuC;EACvC,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,oCAAoC;EACpC,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb;;mBAEiB;AACnB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,4BAA4B;EAC5B,eAAe;AACjB;AACA;EACE,cAAc;AAChB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,cAAc;EACd,eAAe;EACf,2BAA2B;EAC3B,6BAA6B;EAC7B,8CAA8C;EAC9C,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA,OAAO;AACP;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;AACtB;AACA;EACE,SAAO;EACP,WAAW;EACX,kCAAkC;AACpC;AACA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,4BAA4B;EAC5B,mBAAmB;AACrB;AACA;EACE,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;AACA;;;;;;8EAM8E;AAC9E;EACE,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,0BAA0B;EAC1B,4BAA4B;EAC5B,eAAe;EACf,uBAAuB,IAAI,4CAA4C;EACvE,iBAAiB,UAAU,sCAAsC;AACnE;;AAEA,yBAAyB,cAAc,EAAE;;AAEzC;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,qFAAqF;AACrF;EACE;IACE,0BAA0B;IAC1B,4BAA4B;EAC9B;;EAEA;IACE,aAAa;IACb,iCAAiC;EACnC;;EAEA;IACE,kCAAkC;EACpC;EACA;IACE,yBAAyB;IACzB,sBAAsB;EACxB;EACA;IACE,mCAAmC;EACrC;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;;EAEA;IACE,gCAAgC;IAChC,2BAA2B;EAC7B;EACA;IACE,mBAAmB;EACrB;;EAEA,mCAAmC;EACnC;IACE,0BAA0B;EAC5B;AACF;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,gDAAgD;EAChD;;;oEAGkE;EAClE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;;;;;wBAKwB;AACxB;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,kCAAkC;EAClC,wCAAwC;EACxC,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,SAAS;AACX;;AAEA,oBAAoB;AACpB;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,iCAAiC;EACjC,6BAA6B;EAC7B,iCAAiC;EACjC,gCAAgC;AAClC;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,UAAU;EACV,uBAAuB;AACzB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mCAAmC;EACnC,wCAAwC;EACxC,kBAAkB;EAClB,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,8BAA8B;EAC9B,kCAAkC;EAClC,yBAAyB;AAC3B;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,qBAAqB;EACrB,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yCAAyC;AAC3C;AACA,oBAAoB,iBAAiB,EAAE;AACvC,sBAAsB,cAAc,EAAE;AACtC,wBAAwB,cAAc,EAAE,4BAA4B,EAAE;;AAEtE;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;AACd;AACA;EACE,iBAAiB,0BAA0B,EAAE;AAC/C;AACA,gBAAgB,gBAAgB,EAAE,cAAc,EAAE;;AAElD;EACE,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,YAAY;AACd;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;AACA,sBAAsB,cAAc,EAAE,eAAe,EAAE,cAAc,EAAE,mBAAmB,EAAE;;AAE5F,oFAAoF;AACpF,kBAAkB,kBAAkB,EAAE,mBAAmB,EAAE,6CAA6C,EAAE;;AAE1G,mFAAmF;AACnF,eAAe,kBAAkB,EAAE,UAAU,EAAE,WAAW,EAAE,UAAU,EAAE,YAAY,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,mBAAmB,EAAE,SAAS,EAAE;AAC7J,kBAAkB,mBAAmB,EAAE,kBAAkB,EAAE,cAAc,EAAE","sourcesContent":["/* ── Login page ── */\n.lp {\n  min-height: 100dvh;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  background: #f0ebe2;\n}\n\n/* ── LEFT PANEL ── */\n.lp__left {\n  position: relative;\n  overflow: hidden;\n  min-height: 100dvh;\n}\n\n.lp__left-bg {\n  position: absolute;\n  inset: 0;\n}\n\n.lp__left-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center 35%;\n}\n\n.lp__left-overlay {\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(175deg, rgba(20, 30, 18, 0.65) 0%, rgba(20, 30, 18, 0.3) 40%, rgba(15, 22, 12, 0.8) 90%);\n}\n\n.lp__left-content {\n  position: relative;\n  z-index: 1;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  padding: clamp(2rem, 5vw, 3.5rem);\n}\n\n.lp__left-logo {\n  display: flex;\n  align-items: center;\n  gap: 0.8rem;\n}\n\n.lp__brand-name {\n  font-weight: 700;\n  font-size: 0.938rem;\n  letter-spacing: 0.22em;\n  color: #fff;\n  margin: 0;\n  line-height: 1.1;\n}\n.lp__brand-sub {\n  font-size: 0.51rem;\n  letter-spacing: 0.2em;\n  color: rgba(255, 255, 255, 0.45);\n  margin: 0;\n  text-transform: uppercase;\n  line-height: 1.4;\n}\n\n.lp__left-hero {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 0.85rem;\n}\n\n.lp__hero-headline {\n  font-family: var(--font-serif);\n  font-size: clamp(1.8rem, 3.5vw, 3rem);\n  font-weight: 600;\n  color: #fff;\n  margin: 0;\n  line-height: 1.2;\n}\n.lp__hero-rust {\n  color: #d4784a;\n  display: block;\n}\n\n.lp__hero-rule {\n  display: block;\n  width: 2.5rem;\n  height: 3px;\n  background: #b85c38;\n  border-radius: 2px;\n}\n\n.lp__hero-sub {\n  font-size: clamp(0.85rem, 1.2vw, 1rem);\n  color: rgba(255, 255, 255, 0.7);\n  line-height: 1.65;\n  margin: 0;\n}\n\n.lp__left-badge {\n  display: flex;\n}\n.lp__left-badge .wws__badge {\n  width: 90px !important;\n  height: 90px !important;\n}\n\n/* ── RIGHT PANEL ── */\n.lp__right {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: clamp(2rem, 5vw, 3rem) clamp(1.5rem, 4vw, 2.5rem);\n  gap: 1.25rem;\n  background: #f0ebe2;\n}\n\n.lp__card {\n  background: #f0ebe2;\n  border: 1px solid rgba(27, 27, 27, 0.1);\n  border-radius: 14px;\n  padding: clamp(1.75rem, 4vw, 2.5rem);\n  width: 100%;\n  max-width: 440px;\n  position: relative;\n  /* overflow: hidden; */\n  box-shadow: 0 4px 24px rgba(27, 27, 27, 0.08);\n}\n\n.lp__card-mtn {\n  position: absolute;\n  top: -15%;\n  right: 0;\n  width: 55%;\n  height: 42%;\n  overflow: hidden;\n  pointer-events: none;\n  opacity: 0.22;\n}\n.lp__card-mtn img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  object-position: center top;\n  filter: grayscale(1) contrast(1.1);\n}\n\n.lp__card-title {\n  font-family: var(--font-serif);\n  font-size: clamp(1.5rem, 2.5vw, 1.9rem);\n  font-weight: 600;\n  color: #1b1b1b;\n  margin: 0 0 0.35rem;\n  position: relative;\n}\n\n.lp__card-sub {\n  font-size: 0.867rem;\n  color: #6b6258;\n  margin: 0 0 1.75rem;\n  line-height: 1.55;\n}\n\n/* Form */\n.lp__form {\n  display: flex;\n  flex-direction: column;\n  gap: 0.95rem;\n}\n.lp__field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n}\n.lp__label {\n  font-size: 0.836rem;\n  font-weight: 600;\n  color: #1b1b1b;\n}\n\n.lp__label-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.lp__forgot {\n  font-size: 0.765rem;\n  color: #b85c38;\n  text-decoration: none;\n  font-weight: 600;\n}\n.lp__forgot:hover {\n  color: #9e4a28;\n}\n\n.lp__input-wrap {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n.lp__input-icon {\n  position: absolute;\n  left: 0.9rem;\n  font-size: 0.867rem;\n  color: rgba(27, 27, 27, 0.3);\n  pointer-events: none;\n}\n\n.lp__input {\n  width: 100%;\n  border: 1px solid rgba(27, 27, 27, 0.18);\n  border-radius: 8px;\n  background: #fff;\n  padding: 0.8rem 0.9rem 0.8rem 2.6rem;\n  font-size: 0.918rem;\n  color: #1b1b1b;\n  outline: none;\n  transition:\n    border-color 0.2s,\n    box-shadow 0.2s;\n}\n.lp__input::placeholder {\n  color: rgba(27, 27, 27, 0.3);\n}\n.lp__input:focus {\n  border-color: #b85c38;\n  box-shadow: 0 0 0 3px rgba(184, 92, 56, 0.1);\n}\n\n.lp__pw-toggle {\n  position: absolute;\n  right: 0.9rem;\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 0.969rem;\n  color: rgba(27, 27, 27, 0.3);\n  padding: 0.2rem;\n}\n.lp__pw-toggle:hover {\n  color: #1b1b1b;\n}\n\n/* Remember */\n.lp__remember {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  font-size: 0.857rem;\n  color: #1b1b1b;\n  cursor: pointer;\n}\n.lp__remember input {\n  display: none;\n}\n.lp__checkbox-mark {\n  width: 1.05rem;\n  height: 1.05rem;\n  border: 1.5px solid #b85c38;\n  border-radius: 3px;\n  background: #b85c38;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  position: relative;\n}\n.lp__checkbox-mark::after {\n  content: \"\";\n  width: 0.48rem;\n  height: 0.28rem;\n  border-left: 2px solid #fff;\n  border-bottom: 2px solid #fff;\n  transform: rotate(-45deg) translate(1px, -1px);\n  display: block;\n}\n\n/* Submit */\n.lp__submit {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.6rem;\n  width: 100%;\n  background: #b85c38;\n  color: #fff;\n  border: none;\n  border-radius: 7px;\n  padding: 0.95rem;\n  font-weight: 700;\n  font-size: 0.836rem;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  cursor: pointer;\n  transition: background 0.2s;\n  margin-top: 0.15rem;\n}\n.lp__submit:hover:not(:disabled) {\n  background: #9e4a28;\n}\n.lp__submit:disabled {\n  opacity: 0.6;\n  cursor: wait;\n}\n\n/* OR */\n.lp__or {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  margin-block: 0.1rem;\n}\n.lp__or-line {\n  flex: 1;\n  height: 1px;\n  background: rgba(27, 27, 27, 0.12);\n}\n.lp__or-text {\n  font-size: 0.734rem;\n  color: rgba(27, 27, 27, 0.38);\n  white-space: nowrap;\n}\n\n/* Social */\n.lp__social {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0.6rem;\n}\n.lp__social-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.55rem;\n  border: 1px solid rgba(27, 27, 27, 0.16);\n  border-radius: 7px;\n  background: #fff;\n  padding: 0.72rem 0.5rem;\n  font-size: 0.796rem;\n  color: #1b1b1b;\n  cursor: pointer;\n  transition: background 0.15s;\n  white-space: nowrap;\n}\n.lp__social-btn:hover {\n  background: rgba(27, 27, 27, 0.04);\n}\n\n.lp__signup {\n  font-size: 0.836rem;\n  color: #6b6258;\n  text-align: center;\n  margin: 0.85rem 0 0;\n}\n/* These are <button>s, and they were inheriting the browser's own button\n   chrome — a grey face and a rectangular border — so they read as two more\n   buttons on a screen that already has one. This is the Forge secondary\n   link: no box, underlined so it is still obviously interactive, with\n   enough padding to stay a comfortable tap target.\n   The colour is the darker rust: #b85c38 measures 4.01:1 on the cream card\n   and 4.54:1 on white, and this text is small. (UX-REVIEW LOG-001, LOG-012) */\n.lp__signup-link {\n  appearance: none;\n  -webkit-appearance: none;\n  background: none;\n  border: none;\n  border-radius: 0;\n  font: inherit;\n  color: #a4502f;\n  font-weight: 700;\n  text-decoration: underline;\n  text-underline-offset: 0.2em;\n  cursor: pointer;\n  padding: 0.5rem 0.15rem;   /* keeps the tap target tall without a box */\n  margin: -0.5rem 0;         /* ...without pushing the line apart */\n}\n\n.lp__signup-link:hover { color: #8d4524; }\n\n.lp__signup-link:focus-visible {\n  outline: 2px solid #a4502f;\n  outline-offset: 2px;\n  border-radius: 3px;\n}\n\n/* Security */\n.lp__security {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  font-size: 0.734rem;\n  color: #6b6258;\n  max-width: 440px;\n  text-align: center;\n}\n.lp__security svg {\n  font-size: 1.122rem;\n  flex-shrink: 0;\n}\n\n/* ── MOBILE ── matches the image: logo+mountain top, form below, social stacked ── */\n@media (max-width: 767.98px) {\n  .lp {\n    grid-template-columns: 1fr;\n    grid-template-rows: auto 1fr;\n  }\n\n  .lp__left {\n    min-height: 0;\n    height: clamp(220px, 50vw, 320px);\n  }\n\n  .lp__left-content {\n    padding: clamp(1rem, 4vw, 1.75rem);\n  }\n  .lp__left-hero {\n    justify-content: flex-end;\n    padding-bottom: 0.5rem;\n  }\n  .lp__hero-headline {\n    font-size: clamp(1.4rem, 6vw, 2rem);\n  }\n  .lp__hero-sub {\n    display: none;\n  }\n  .lp__left-badge {\n    display: none;\n  }\n\n  .lp__right {\n    padding: var(--sp-5) var(--sp-4);\n    justify-content: flex-start;\n  }\n  .lp__card {\n    border-radius: 10px;\n  }\n\n  /* On mobile social buttons stack */\n  .lp__social {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* ── Mode toggle (OTP vs Password) ── */\n.lp__mode-toggle {\n  display: flex;\n  border: 1.5px solid var(--c-sand, #ddd5c8);\n  border-radius: 8px;\n  overflow: hidden;\n  margin-bottom: 1.5rem;\n}\n.lp__mode-btn {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.4rem;\n  padding: 0.6rem 0.5rem;\n  font-size: 0.82rem;\n  font-weight: 600;\n  background: #fff;\n  border: none;\n  cursor: pointer;\n  color: #6b6258;\n  border-right: 1.5px solid var(--c-sand, #ddd5c8);\n  /* Background and colour change together, so the selected state can never\n     paint half-applied. `transition: all` used to animate the background\n     from near-black to white while the text went from white to grey, and\n     both were pale in the middle of the swap. (UX-REVIEW LOG-003) */\n  transition: none;\n}\n.lp__mode-btn:last-child {\n  border-right: none;\n}\n/* The real cause of the white-on-white report. `.lp__mode-btn:hover` is a\n   more specific selector than `.lp__mode-btn--active`, so hovering the\n   SELECTED method kept the near-white hover tint underneath its white\n   label — permanently, for anyone using a mouse, not just for a frame.\n   Hover now applies only to the method you have not chosen.\n   (UX-REVIEW LOG-003) */\n.lp__mode-btn:hover:not(.lp__mode-btn--active) {\n  background: #faf7f2;\n}\n.lp__mode-btn--active {\n  background: #1e2a1e;\n  color: #fff;\n}\n\n/* ── OTP sent notice ── */\n.lp__otp-sent-notice {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n  background: rgba(30, 42, 30, 0.06);\n  border: 1px solid rgba(30, 42, 30, 0.14);\n  border-radius: 8px;\n  padding: 0.85rem 1rem;\n  margin-bottom: 1.25rem;\n}\n.lp__otp-sent-icon {\n  font-size: 1.35rem;\n  color: #1e2a1e;\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n.lp__otp-sent-title {\n  font-size: 0.85rem;\n  font-weight: 700;\n  color: #1b1b1b;\n  margin: 0 0 0.15rem;\n}\n.lp__otp-sent-sub {\n  font-size: 0.78rem;\n  color: #6b6258;\n  margin: 0;\n}\n\n/* ── OTP input ── */\n.lp__input--otp {\n  font-size: 1.6rem !important;\n  font-weight: 800 !important;\n  letter-spacing: 0.35em !important;\n  text-align: center !important;\n  font-family: monospace !important;\n  padding: 0.85rem 1rem !important;\n}\n\n/* ── OTP footer actions ── */\n.lp__otp-footer {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 0.75rem;\n}\n.lp__otp-hint {\n  font-size: 0.75rem;\n  color: #6b6258;\n  text-align: center;\n  margin-top: 0.75rem;\n}\n\n/* ── Link buttons ── */\n.lp__link-btn {\n  background: none;\n  border: none;\n  font-size: 0.78rem;\n  color: #6b6258;\n  cursor: pointer;\n  padding: 0;\n  transition: color 0.15s;\n}\n.lp__link-btn:hover {\n  color: #b85c38;\n}\n.lp__link-btn:disabled {\n  opacity: 0.45;\n  cursor: default;\n}\n\n/* ── Error message ── */\n.lp__error {\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: #dc2626;\n  background: rgba(220, 38, 38, 0.07);\n  border: 1px solid rgba(220, 38, 38, 0.2);\n  border-radius: 6px;\n  padding: 0.55rem 0.75rem;\n  margin-bottom: 0.75rem;\n}\n\n/* ── Sign in / Create account tabs ── */\n.lp__view-tabs {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  border-bottom: 1.5px solid #e4dccf;\n  margin: 0.25rem 0 1.25rem;\n}\n.lp__view-tab {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.45rem;\n  padding: 0.75rem 0.5rem;\n  background: none;\n  border: none;\n  border-bottom: 3px solid transparent;\n  margin-bottom: -1.5px;\n  font: inherit;\n  font-size: 0.9rem;\n  font-weight: 700;\n  color: #6b6258;\n  cursor: pointer;\n  transition: color 0.2s, border-color 0.2s;\n}\n.lp__view-tab svg { font-size: 1.1rem; }\n.lp__view-tab:hover { color: #1b1b1b; }\n.lp__view-tab--active { color: #1e2a1e; border-bottom-color: #b85c38; }\n\n.lp__field-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0.75rem;\n}\n@media (max-width: 420px) {\n  .lp__field-row { grid-template-columns: 1fr; }\n}\n.lp__optional { font-weight: 400; color: #8a8178; }\n\n.lp__reg-points {\n  list-style: none;\n  margin: 0.25rem 0 0;\n  padding: 0.9rem 1rem;\n  background: #f6f0e8;\n  border-radius: 10px;\n  display: grid;\n  gap: 0.45rem;\n}\n.lp__reg-points li {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.5rem;\n  font-size: 0.8rem;\n  color: #4a433c;\n  line-height: 1.45;\n}\n.lp__reg-points svg { color: #16a34a; font-size: 1rem; flex-shrink: 0; margin-top: 0.05rem; }\n\n/* \"Stayed with Makua?\" under the sign-in form, only when the forum sent them here */\n.lp__other-site { margin-top: 1.1rem; padding-top: 0.9rem; border-top: 1px solid rgba(107, 98, 88, 0.18); }\n\n/* Visually hidden, still read by password managers (the new password's username) */\n.lp__sr-only { position: absolute; width: 1px; height: 1px; padding: 0; margin: -1px; overflow: hidden; clip: rect(0 0 0 0); white-space: nowrap; border: 0; }\n.lp__field-hint { margin: 0.35rem 0 0; font-size: 0.78rem; color: #6b6258; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
